'use client'

import { FileQuestion } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface NotFoundProps {
	reset?: () => void
}

export default function NotFound({ reset }: NotFoundProps) {
	return (
		<div className="flex min-h-dvh flex-col items-center justify-center p-8">
			<div className="text-center">
				<FileQuestion className="text-muted-foreground mx-auto h-16 w-16" />
				<h1 className="mt-6 text-4xl font-bold">404</h1>
				<h2 className="mt-2 text-xl font-semibold">Página no encontrada</h2>
				<p className="text-muted-foreground mt-4">
					La página que buscas no existe o ha sido movida.
				</p>
				<div className="mt-8 flex justify-center gap-4">
					{reset && (
						<Button onClick={reset} variant="outline">
							Intentar de nuevo
						</Button>
					)}
					<Button onClick={() => (window.location.href = '/')}>Volver al inicio</Button>
				</div>
			</div>
		</div>
	)
}
